<template>
	<component :is="cmpname" :options='options' :attrs="attrs"></component>
</template>

<script>
import Mods from '@/common/mods';

export default
{
	data (){
		return {cmpname: 'loading'}
	},
	created (){
		let timer = setInterval(() => {
			let modname = this.attrs.type,
			modcmp = Mods.get_plugin_property(modname);
			if (! modcmp) return true;

			clearInterval(timer);
			this.cmpname = `property_${modname}`;
			this.$options.components[this.cmpname] = modcmp
		}, 500)
	},
	components: {
		loading: {
			template: '<div style="color: #999;line-height: 2;text-align: center;">加载中...</div>',
		},
	},
	props: ['options', 'attrs']
}
</script>


// WEBPACK FOOTER //
// modproperty.vue?36b8280c